/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";

// Helper
import pxToRem from "assets/theme/functions/pxToRem";

const { inputBorderColor, inputFilledColor, text } = colors;
const { borderRadius } = borders;
const { fontWeightRegular } = typography;

const textField = {
  styleOverrides: {
    root: {
      backgroundColor: inputFilledColor,
      borderRadius: borderRadius.md,
      fontWeight: fontWeightRegular,
      fontSize: pxToRem(14),
      color: text.primary,

      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: inputBorderColor,
        },
        "&:hover fieldset": {
          borderColor: "#2F80ED",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#2F80ED",
          boxShadow: `0 0 0 2px rgba(47, 128, 237, 0.1)`,
        },
      },
    },
  },
};

export default textField;
